import { render, staticRenderFns } from "./MenuNew.vue?vue&type=template&id=8a02d624&scoped=true&"
import script from "./MenuNew.vue?vue&type=script&lang=js&"
export * from "./MenuNew.vue?vue&type=script&lang=js&"
import style0 from "./MenuNew.vue?vue&type=style&index=0&id=8a02d624&lang=scss&scoped=true&"
import style1 from "./MenuNew.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a02d624",
  null
  
)

export default component.exports